import { PredefinedCommentFormModel } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import {
    CreatePredefinedCommentInputAPI,
    PredefinedCommentDetailAPI,
    UpdatePredefinedCommentInputAPI,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/service/predefined-comments-queries.api';

export const mapPredefinedCommentFormToAPI = (
    formData: PredefinedCommentFormModel
): CreatePredefinedCommentInputAPI | UpdatePredefinedCommentInputAPI => ({
    commentText: formData.commentText,
    deviceTypes: formData.deviceTypeEntries
        .filter((e) => e.deviceTypeId)
        .map((e) => ({
            id: e.deviceTypeId!,
            resultTypeIds: e.resultTypes,
            erroneous: e.erroneous,
            locationIds: e.locations,
            order: e.order!,
        })),
    active: formData.active,
});

export const mapPredefinedCommentApiToForm = (pdc: PredefinedCommentDetailAPI): PredefinedCommentFormModel => ({
    commentText: pdc.commentText,
    deviceTypeEntries: pdc.deviceTypes.map((dt) => ({
        id: dt.id,
        resultTypes: dt.resultTypeIds,
        locations: dt.locationIds,
        erroneous: dt.erroneous,
        deviceTypeId: dt.id,
        order: dt.order,
    })),
    active: pdc.active,
});
